// GAVION booking: the frame of the public pages (no CRM chrome): the Gavion logo (light/dark) and the FR/EN switch.
// Colours come from the theme tokens only, so the page follows the visitor's light or dark preference.
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import darkModeLogo from "../../../atomic-crm/root/logos/logo_gavion_dark.png";
import lightModeLogo from "../../../atomic-crm/root/logos/logo_gavion_light.png";
import { BOOKING_COPY, type PublicLang } from "./copy";

export const PublicShell = ({
  lang,
  onLang,
  children,
}: {
  lang: PublicLang;
  onLang?: (l: PublicLang) => void;
  children: ReactNode;
}) => (
  <div lang={lang} className="min-h-screen bg-muted/30 pb-8 text-foreground">
    <header className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4">
      <span>
        <img src={darkModeLogo} alt="Gavion" className="h-8 w-auto [.light_&]:hidden" />
        <img src={lightModeLogo} alt="Gavion" className="h-8 w-auto [.dark_&]:hidden" />
      </span>
      {onLang && (
        <Button variant="link" size="sm" onClick={() => onLang(lang === "fr" ? "en" : "fr")}>
          {BOOKING_COPY[lang].switchLang}
        </Button>
      )}
    </header>
    <main className="mx-3 max-w-3xl rounded-xl bg-background p-4 shadow-sm sm:mx-auto sm:p-6">{children}</main>
  </div>
);

/** The rep's photo, or their initials while the profile has none. */
export const RepAvatar = ({ firstName, lastName, avatarUrl }: { firstName: string; lastName: string; avatarUrl: string | null }) =>
  avatarUrl ? (
    <img src={avatarUrl} alt="" className="size-12 shrink-0 rounded-full object-cover" />
  ) : (
    <span
      aria-hidden="true"
      className="flex size-12 shrink-0 items-center justify-center rounded-full bg-primary text-lg font-semibold text-primary-foreground"
    >
      {`${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()}
    </span>
  );
